import { render, staticRenderFns } from "./Assesment.vue?vue&type=template&id=de1dba48&scoped=true&"
import script from "./Assesment.vue?vue&type=script&lang=js&"
export * from "./Assesment.vue?vue&type=script&lang=js&"
import style0 from "./Assesment.vue?vue&type=style&index=0&id=de1dba48&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1dba48",
  null
  
)

export default component.exports